/* eslint-disable @typescript-eslint/no-shadow */
export default function animate({
  timing,
  draw,
  duration,
  end,
}: {
  timing: (val: number) => number;
  draw: (progress: number) => void;
  duration: number;
  end?: () => void;
}) {
  const start = performance.now();

  requestAnimationFrame(function animate(time) {
    // timeFraction изменяется от 0 до 1

    let timeFraction = (time - start) / duration;
    if (timeFraction > 1) timeFraction = 1;

    // вычисление текущего состояния анимации
    const progress = timing(timeFraction);

    draw(progress); // отрисовать её

    if (timeFraction < 1) {
      requestAnimationFrame(animate);
    } else if (end) {
      end();
    }
  });
}

export function easeOut(t: number): number {
  return 1 - (1 - t) ** 2;
}
export function easeInOut(t: number): number {
  if (t < 0.5) {
    return 2 * t * t;
  }
  return 1 - 2 * (1 - t) * (1 - t);
}
